import { API } from "shared/constants/AppEnums"

export const getTreeTM = async (sort) => {
    try {
        const response = await fetch(API.GET_TREE_TM.replace('$sort', sort), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const addCategory = async (data) => {
    try {
        const response = await fetch(API.ADD_CATEGORY, {
            method: 'POST',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const putCategory = async (data, id_project) => {
    try {
        const response = await fetch(API.PUT_CATEGORY.replace('$id', id_project), {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const deleteCategory = async (id_project) => {
    try {
        const response = await fetch(API.DELETE_CATEGORY.replace('$id', id_project), {
            method: 'DELETE',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const addFolder = async (data) => {
    try {
        const response = await fetch(API.ADD_FOLDER, {
            method: 'POST',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const addList = async (data) => {
    try {
        const response = await fetch(API.ADD_LIST, {
            method: 'POST',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const putList = async (data, id_list) => {
    try {
        const response = await fetch(API.PUT_LIST.replace('$id', id_list), {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const deleteList = async (id_list) => {
    try {
        const response = await fetch(API.DELETE_LIST.replace('$id', id_list), {
            method: 'DELETE',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const addTask = async (data) => {
    try {
        const response = await fetch(API.ADD_TASK, {
            method: 'POST',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const putTask = async (data, id_task) => {
    try {
        const response = await fetch(API.PUT_TASK.replace('$id', id_task), {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const updateStatusTask = async (data, id_task) => {
    try {
        const response = await fetch(API.UPDATE_STATUS_TASK.replace('$id', id_task), {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const updateStatusKorespondensi = async (data, id_task) => {
    try {
        const response = await fetch(API.UPDATE_STATUS_KORESPONDENSI.replace('$id', id_task), {
            method: 'POST',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getListTM = async (id_list) => {
    try {
        const response = await fetch(API.GET_LIST_TM.replace('$id', id_list), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDashboardTM = async (id_project, status, my_task) => {
    try {
        const response = await fetch(API.GET_DASHBOARD_TM.replace('$project_id', id_project).replace('$status', status).replace('$my_task', my_task), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDashboardCountTM = async (id_project, my_task) => {
    try {
        const response = await fetch(API.GET_DASHBOARD_COUNT_TM.replace('$project_id', id_project).replace('$my_task', my_task), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getKorespondensiTM = async (status) => {
    try {
        const response = await fetch(API.GET_KORESPONDENSI_TM.replace('$status', status), {
            method: 'GET',
            headers: {
                'Authorization': `${sessionStorage.getItem('token')}`,
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getMonitoringTM = async (project_id, search) => {
    try {
        const response = await fetch(API.GET_MONITORING_TM.replace('$project_id', project_id).replace('$general', search), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getProjectChoiceTM = async () => {
    try {
        const response = await fetch(API.GET_PROJECT_CHOICE_TM, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const addAttachmentTask = async (file) => {
    try {
        var formData = new FormData()
        formData.append("file", file)

        const response = await fetch(API.ADD_ATTACHMENT_TM, {
            method: 'POST',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            },
            body: formData
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getProjectDetailTM = async (id_project) => {
    try {
        const response = await fetch(API.GET_PROJECT_DETAIL_TM.replace('$id', id_project), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getTaskDetailTM = async (id_task) => {
    try {
        const response = await fetch(API.GET_TASK_DETAIL_TM.replace('$id', id_task), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getTaskDetailKorespondensiTM = async (id_task) => {
    try {
        const response = await fetch(API.GET_TASK_DETAIL_KORESPONDENSI_TM.replace('$id', id_task), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getExportMonitoing = async () => {
    try {
        const response = await fetch(API.GET_EXPORT_MONITORING_TM, {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const addCommentTask = async (payload) => {
    try {
        const response = await fetch(API.ADD_COMMENT_TM, {
            method: 'POST',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })

        return response.json()
    } catch (error) {
        return error
    }
}

export const deleteTaskTM = async (id) => {
    try {
        const response = await fetch(API.DELETE_TASK_TM.replace('$id', id), {
            method: 'DELETE',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}
